import {
    IonContent,
    IonPage,
    IonAlert,
    IonActionSheet,
    useIonViewDidEnter,
} from '@ionic/react'
import React, { useState } from 'react'
import './Home.css'
import {
    BindWxIcon,
    KnowledgeIcon,
    MyBotIcon,
    StudyIcon,
    HelpIcon,
    BotStoreIcon,
    BotLogoutIcon,
    GroupIcon,
    BotIcon,
} from '../conf/images'
import IconLink from '../components/IconLink'
import { useSelector, useDispatch } from 'react-redux'
import { ReduxStore } from '../redux/reducers'
import { UserModel } from '../model/user.model'
import { getWechatBotSettings } from '../service/api/bot'
import {
    // BindBotPage,
    MyKnowledgePage,
    MyBotPage,
    LearningPage,
    BotStorePage,
    SigninPage,
    BindWechatPage,
    WechatBotPage,
    ProductIntroPage,
    PasswordPage,
    NoticePage,
    ManageGroupPage,
} from '../conf/routePath'
import { BotSettings } from '../model/bot.model'
import { setBotSettingsInfo } from '../redux/actions/settings'
import { useHistory } from 'react-router'

const Header = () => {
    const history = useHistory()
    const [alertOptions, setAlertOptions] = useState({
        isOpen: false,
        onDidDismiss: () => {
            setAlertOptions({
                ...alertOptions,
                isOpen: false,
            })
        },
        message: '是否退出登录',
    })

    const [showActionSheet, setShowActionSheet] = useState(false)

    const userInfo = useSelector<ReduxStore, UserModel | null>(
        (state) => state.userInfo
    )
    const handleSignout = () => {
        // window.location.replace(SigninPage)
        setAlertOptions({
            ...alertOptions,
            isOpen: true,
        })
    }
    return (
        <div className='header'>
            <div onClick={() => setShowActionSheet(true)}>
                <img className='logo' src={BotIcon} alt='icon' />
                <p className='username'>{userInfo && userInfo.nickname}</p>
            </div>
            <IonActionSheet
                isOpen={showActionSheet}
                onDidDismiss={() => setShowActionSheet(false)}
                buttons={[
                    {
                        text: '系统通知',
                        handler: () => {
                            history.push(NoticePage)
                        },
                    },
                    {
                        text: '修改密码',
                        handler: () => {
                            history.push(PasswordPage)
                        },
                    },
                    {
                        text: '退出登录',
                        role: 'destructive',
                        handler: handleSignout,
                    },
                ]}
            />

            <IonAlert
                {...alertOptions}
                buttons={[
                    {
                        text: '取消',
                        handler: () => {
                            setAlertOptions({
                                ...alertOptions,
                                isOpen: false,
                            })
                        },
                    },
                    {
                        text: '确认',
                        handler: () => {
                            setAlertOptions({
                                ...alertOptions,
                                isOpen: false,
                            })
                            window.location.replace(SigninPage)
                        },
                    },
                ]}
            />
        </div>
    )
}

interface MenuWrapperProps {
    className?: string
}
const MenuWrapper: React.FC<MenuWrapperProps> = (props) => {
    const { className } = props
    return (
        <div className={`menu-wrapper ${className}`}>
            <div className='menu-list'>{props.children}</div>
        </div>
    )
}
const Home: React.FC = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const botSettings = useSelector<ReduxStore, BotSettings | null>(
        (store) => store.settingsInfo
    )
    const [logoutAlertShow, setLogoutAlertShow] = useState(false)
    const logoutOptions = {
        onDidDismiss: () => {
            setLogoutAlertShow(false)
        },
        message: `<div class="logout-dialog">
            <img class="logout-icon" src=${BotLogoutIcon} />
            <p class="logout-tip">您的机器人掉线啦，请重新绑定</p>
        </div>`,
    }
    useIonViewDidEnter(() => {
        loadBotSettings()
    })
    const loadBotSettings = async () => {
        try {
            let res = await getWechatBotSettings()
            dispatch(setBotSettingsInfo(res))
            let isLogout = !res.is_online && !!res.offline_reason
            let LogoutStatusKey = 'HasLogoutTip'
            let hasLogoutTip = sessionStorage.getItem(LogoutStatusKey)
            if (isLogout && !hasLogoutTip) {
                sessionStorage.setItem(LogoutStatusKey, '1')
                setLogoutAlertShow(isLogout)
            }
            // setHasLogoutTip(true)
        } catch (error) {
            console.error(error)
        }
    }
    return (
        <IonPage className='home-page'>
            <IonContent className='home-content'>
                <Header />
                <MenuWrapper className='menu-top'>
                    <IconLink
                        className='menu'
                        to={
                            botSettings && botSettings.is_online
                                ? WechatBotPage
                                : BindWechatPage
                        }
                        imgSrc={
                            botSettings && botSettings.is_online
                                ? botSettings.bot_head_url
                                : BindWxIcon
                        }
                        title={
                            botSettings && botSettings.is_online
                                ? '机器人'
                                : '绑定机器人'
                        }
                    />
                </MenuWrapper>
                <MenuWrapper className='menu-middle'>
                    <IconLink
                        className='menu'
                        to={MyKnowledgePage}
                        imgSrc={KnowledgeIcon}
                        title='我的知识'
                    />
                    <IconLink
                        className='menu'
                        to={MyBotPage}
                        imgSrc={MyBotIcon}
                        title='我的应用'
                    />
                    <IconLink
                        className='menu'
                        to={LearningPage}
                        imgSrc={StudyIcon}
                        title='持续学习'
                    />
                </MenuWrapper>
                <MenuWrapper className='menu-bottom'>
                    <IconLink
                        className='menu'
                        to={BotStorePage}
                        imgSrc={BotStoreIcon}
                        title='应用商店'
                    />
                    <IconLink
                        className='menu'
                        to={ProductIntroPage}
                        imgSrc={HelpIcon}
                        title='帮助中心'
                    />
                    <IconLink
                        className='menu'
                        to={ManageGroupPage}
                        imgSrc={GroupIcon}
                        title='群管理'
                    />
                </MenuWrapper>
            </IonContent>
            <IonAlert
                isOpen={logoutAlertShow}
                {...logoutOptions}
                buttons={[
                    {
                        text: '先等会',
                        handler: () => {
                            setLogoutAlertShow(false)
                        },
                    },
                    {
                        text: '确认',
                        handler: () => {
                            setLogoutAlertShow(false)
                            history.push(BindWechatPage)
                        },
                    },
                ]}
            />
        </IonPage>
    )
}

export default Home
